export default function (url, parameters) {
  let qs = ''
  for (const key in parameters) {
    const value = parameters[key]
    qs += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
  }
  if (qs.length > 0) {
    qs = qs.substring(0, qs.length - 1) // chop off last "&"
    url = `${url}?${qs}`
  }
  return url
}
